"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPhoneNumber = void 0;
var transformPhoneNumber = function (phoneNumber) {
    var phone = phoneNumber.toString();
    if (phone.length > 10) {
        return "+".concat(phone.slice(0, 1), " (").concat(phone.slice(1, 4), ") ").concat(phone.slice(4, 7), "-").concat(phone.slice(7, 9), "-").concat(phone.slice(9));
    }
    return "+7 (".concat(phone.slice(0, 3), ") ").concat(phone.slice(3, 6), "-").concat(phone.slice(6, 8), "-").concat(phone.slice(8));
};
exports.transformPhoneNumber = transformPhoneNumber;
